'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineOppositeContentProps } from '@mui/lab/TimelineOppositeContent';

import MuiTimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

export type { TimelineOppositeContentProps };

export const TimelineOppositeContent: React.FC<TimelineOppositeContentProps> =
  MuiTimelineOppositeContent;

TimelineOppositeContent.displayName = 'TimelineOppositeContent';
